/* global XLSX */
'use strict';

import angular from 'angular';
import XLSX from 'xlsx';
import raven from 'raven';

import FormController from 'app/controllers/form';
import ListChooseController from './list-choose.controller';
import ListChooseTpl from './list-choose.html';

class GroupInvoiceController extends FormController {
  /* @ngInject */
  constructor(
    GroupInvoicesService,
    ClientsService,
    QuotesService,
    $scope,
    $mdDialog,
    $mdToast,
    $state,
    $location
  ) {
    let groupInvoice = $scope.$parent.$resolve.groupInvoice;
    super(groupInvoice, 'Remito', GroupInvoicesService, null, 'group-invoices');

    Object.assign(this, {
      GroupInvoicesService,
      ClientsService,
      QuotesService,
      $mdDialog,
      $mdToast,
      $state,
      $location
    });
  }

  $onInit() {
    super.$onInit();
    if (this.model.id) {
      // edit
      this.client = this.model.client;
      this.quotes = this.model.quotes;
      this.receipts = this.model.receipts;
      this.loadAvailableQuotes();
    } else {
      // new
      this.model.date = new Date();
      this.model.status = 'draft';
    }
    this.updateClientChangeStatus();
    this.updateStatus();

    if (!this.model.lists || !Object.keys(this.model.lists).length) {
      this.model.lists = {
        Base: this.quotes.map(q => q.id)
      };
    }

    this.loadLists();
  }

  calcListTotals() {
    this.listTotals = {};
    for (let list in this.lists) {
      this.listTotals[list] = this.lists[list].reduce(
        (sum, quote) => sum + quote.totalFinalAmount,
        0
      );
    }
  }

  loadLists() {
    this.lists = {};
    for (let list in this.model.lists) {
      let quoteIds = this.model.lists[list];
      this.lists[list] = this.quotes.filter(quote =>
        quoteIds.find(qId => qId == quote.id)
      );
    }
    this.calcListTotals();
  }

  getSortedLists() {
    return Object.keys(this.lists).sort(
      (a, b) => a.toUpperCase() > b.toUpperCase()
    );
  }

  removeList(listName) {
    if (Object.keys(this.lists).length == 1) {
      return;
    }
    let orphanQuotes = this.lists[listName];
    delete this.lists[listName];
    let firstList = this.getSortedLists().shift();
    this.lists[firstList].push(...orphanQuotes);
    this.calcListTotals();
  }

  saveLists() {
    this.model.lists = {};
    for (let list in this.lists) {
      this.model.lists[list] = this.lists[list].map(quote => quote.id);
    }
  }

  beforeSave() {
    this.saveLists();
  }

  afterSave() {
    this.loadAvailableQuotes();
  }

  updateStatus() {
    this.canEditQuotes = this.model.status == 'draft';
  }

  afterModelSave() {
    this.updateClientChangeStatus();
    this.updateStatus();
  }

  beforeEdit() {
    if (this.quotes) {
      this.quotesCopy = JSON.parse(JSON.stringify(this.quotes));
    }
  }

  afterReset() {
    this.quotes = this.quotesCopy;
  }

  selectedClientChange(client) {
    if (!client) {
      return Promise.resolve();
    }
    this.model.client = client;
    this.client = client;
    return Promise.resolve()
      .then(() => {
        if (!this.model.id) {
          return this.save();
        }
      })
      .then(() => {
        this.loadAvailableQuotes();
      });
  }

  afterFirstSave() {
    this.edit();
  }

  queryClientSearch() {
    return this.ClientsService.findByName(this.searchClientText);
  }

  getClientName(client) {
    if (client) return client.lastName + ' ' + client.name;
  }

  calcQuote(id) {
    let quoteData = this.model.metadata.quotes[id];
    quoteData.amount = quoteData.fee + quoteData.spendings;
  }

  export() {
    var wb = XLSX.utils.book_new();
    let wsData = [];
    for (let list of this.getSortedLists()) {
      wsData.push([list]);
      wsData.push([
        'OT',
        'Dominio',
        'Titular',
        'Tramite',
        'Gastos',
        'Honorarios',
        'Total'
      ]);
      for (let q of this.lists[list]) {
        wsData.push([
          q.id,
          q.vehicle.plate,
          q.holder.lastName + ' ' + q.holder.name,
          this.model.metadata.quotes[q.id].comments,
          this.model.metadata.quotes[q.id].spendings / 100,
          this.model.metadata.quotes[q.id].fee / 100,
          this.model.metadata.quotes[q.id].amount / 100
        ]);
      }
      wsData.push(['', '', '', '', '', '', this.listTotals[list] / 100]);
      wsData.push([]);
    }

    const sheetName = 'Remito ' + this.model.id;
    var ws = XLSX.utils.aoa_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    wb.Sheets[sheetName]['!cols'] = [
      {
        width: 10
      },
      {
        width: 15
      },
      {
        width: 30
      },
      {
        width: 30
      },
      {
        width: 10
      },
      {
        width: 10
      },
      {
        width: 10
      }
    ];

    XLSX.writeFile(wb, `remito-${this.model.id}.xlsx`);
  }

  updateClientChangeStatus() {
    this.canChangeClient =
      this.model.id && Object.keys(this.model.metadata).length ? false : true;
  }

  removeQuote($event, quote) {
    const index = this.quotes.findIndex(q => q.id == quote.id);
    this.quotes.splice(index, 1);
    delete this.model.metadata.quotes[quote.id];
    this.model.groupInvoiceId = null;

    for (let list in this.lists) {
      let index = this.lists[list].findIndex(q => q.id == quote.id);
      if (index > -1) {
        this.lists[list].splice(index, 1);
      }
    }
    this.calcListTotals();
  }

  addQuote() {
    this.getList().then(list => {
      this.GroupInvoicesService.addQuotes({
        quoteIds: [this.addQuoteId],
        groupInvoiceId: this.model.id
      }).then(
        res => {
          Object.assign(this.model, res.groupInvoice);
          const quote = res.groupInvoice.quotes.find(
            q => q.id == this.addQuoteId
          );
          this.quotes.push(quote);
          this.lists[list].push(quote);
          this.saveLists();
          this.calcListTotals();
          this.model.$save();
          this.simpleSuccess();
        },
        err => {
          this.simpleError();
        }
      );
    });
  }

  getList() {
    const lists = Object.keys(this.lists);
    if (lists.length == 1) {
      return Promise.resolve(lists[0]);
    }

    return this.$mdDialog
      .show({
        controller: ListChooseController,
        template: ListChooseTpl,
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          lists: lists
        }
      })
      .then(data => {
        return data.list;
      });
  }

  loadAvailableQuotes() {
    if (this.client) {
      this.QuotesService.getModels({
        where: {
          clientId: this.client.id,
          groupInvoiceId: null,
          notInvoiceable: null,
          createdAt: {
            gt: new Date(2018, 4, 1)
          },
          approvedAt: {
            neq: null
          }
        },
        order: 'createdAt ASC',
        include: ['holder', 'vehicle', 'procedures', 'receipts']
      }).then(res => {
        this.availableQuotes = res.result.quotes
          .filter(
            q =>
              !q.groupInvoiceHistory ||
              !q.groupInvoiceHistory.length ||
              q.forcedAvailability
          )
          .filter(q => q.receipts.length == 0);
        this.pendingQuotes = res.result.quotes
          .filter(
            q =>
              q.groupInvoiceHistory &&
              q.groupInvoiceHistory.length &&
              !q.forcedAvailability
          )
          .filter(q => q.receipts.length == 0);
      });
    }
  }

  addPendingQuote(q) {
    this.addAvailableQuote(q, this.pendingQuotes);
  }

  addAvailableQuote(quote, sourceList) {
    if (!sourceList) {
      sourceList = this.availableQuotes;
    }
    this.getList().then(list => {
      this.GroupInvoicesService.addQuotes({
        quoteIds: [quote.id],
        groupInvoiceId: this.model.id
      }).then(
        res => {
          Object.assign(this.model, res.groupInvoice);
          const updatedQuote = res.groupInvoice.quotes.find(
            q => q.id == quote.id
          );
          this.quotes.push(updatedQuote);

          const index = sourceList.findIndex(q => q.id == quote.id);
          if (index > -1) {
            sourceList.splice(index, 1);
          } else {
            raven.captureMessage(`Quote not found`, {
              quoteId: quote.id,
              groupInvoiceId: this.model.id
            });
            this.simpleError();
            return;
          }

          this.lists[list].push(quote);
          this.saveLists();
          this.calcListTotals();
          this.model.$save();
          this.simpleSuccess();
        },
        err => {
          this.simpleError();
        }
      );
    });
  }

  makeForcedAvailable(quote) {
    quote.forcedAvailability = true;
    this.QuotesService.save(quote).then(
      () => {
        this.simpleSuccess();
        const index = this.pendingQuotes.findIndex(q => q.id == quote.id);
        if (index > -1) {
          this.pendingQuotes.splice(index, 1);
        }
        this.availableQuotes.unshift(quote);
      },
      err => {
        raven.captureException(err);
        this.simpleError();
      }
    );
  }

  undoForcedAvailable(quote) {
    if (!quote.forcedAvailability) {
      return;
    }
    quote.forcedAvailability = false;
    this.QuotesService.save(quote).then(
      () => {
        this.simpleSuccess();
        const index = this.availableQuotes.findIndex(q => q.id == quote.id);
        if (index > -1) {
          this.availableQuotes.splice(index, 1);
        }
        this.pendingQuotes.unshift(quote);
      },
      err => {
        raven.captureException(err);
        this.simpleError();
      }
    );
  }

  getGroupInvoiceHistory(quote, type = 'add') {
    return (quote.groupInvoiceHistory || []).filter(
      item => item.action == type
    );
  }

  addList(ev) {
    var confirm = this.$mdDialog
      .prompt()
      .title('Agregar lista')
      .placeholder('Nombre')
      .ariaLabel('Nombre')
      .required(true)
      .targetEvent(ev)
      .ok('Agregar')
      .cancel('Cancelar');

    this.$mdDialog.show(confirm).then(result => {
      this.lists[result] = [];
      this.calcListTotals();
    });
  }
}

export { GroupInvoiceController as default };
